var render = function render(_c,_vm){return _c('div',_vm._l((_vm.props.dataset),function(data,idx){return _c('div',{key:idx},[_c('label',[_vm._v(_vm._s(data.title))]),_c('ul',{staticClass:"tags"},_vm._l((data.tags),function(tag,idx){return _c('li',{key:tag+idx,staticClass:"tag"},[_vm._v(_vm._s(tag.substring(0, tag.length)))])}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }